"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog.default;
  }
});

var _Dialog = _interopRequireDefault(require("./Dialog"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Dialog/index.js
// module id = 853
// module chunks = 0